import { useEffect, useState } from "react";
import { Check, AlertTriangle, Clock, ClipboardList, Bell, Info } from "lucide-react";
import { api } from "../lib/apiClient";
import { PageHeader, Empty } from "../components/Shared";
import { toast } from "sonner";

const ICONS = { deadline: Clock, buffer: AlertTriangle, overdue: AlertTriangle, review: ClipboardList };
const SEV = {
  critical: { c: "#EF4444", bg: "rgba(239,68,68,0.12)" }, warning: { c: "#F59E0B", bg: "rgba(245,158,11,0.12)" },
  info: { c: "#3B82F6", bg: "rgba(59,130,246,0.12)" }, success: { c: "#10B981", bg: "rgba(16,185,129,0.12)" },
};

function getRead() { return JSON.parse(localStorage.getItem("kra_read") || "[]"); }
function setRead(ids) { localStorage.setItem("kra_read", JSON.stringify(ids)); }

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [read, setReadState] = useState(getRead());

  useEffect(() => { api.notifications().then(setItems).catch(() => {}); }, []);

  const isRead = (id) => read.includes(id);
  const readOne = (id) => { const r = [...new Set([...read, id])]; setRead(r); setReadState(r); };
  const readAll = () => { const r = [...new Set([...read, ...items.map((i) => i.id)])]; setRead(r); setReadState(r); toast.success("All marked as read"); };
  const unread = items.filter((i) => !isRead(i.id)).length;

  return (
    <div>
      <PageHeader title="Notifications & Alerts" subtitle={`${unread} unread · live deadline, 48-hour buffer and overdue alerts per task`}>
        <button onClick={readAll} className="pill px-3 py-2 text-sm font-semibold surface border-strong hover:brand-text transition-colors" data-testid="mark-all-read-button"><Check size={15} /> Mark all read</button>
      </PageHeader>

      <div className="space-y-3 max-w-3xl">
        {items.map((n) => {
          const Icon = ICONS[n.type] || Info; const sev = SEV[n.severity] || SEV.info; const r = isRead(n.id);
          return (
            <div key={n.id} className={`card-panel p-4 flex items-start gap-4 ${r ? "opacity-60" : ""}`} data-testid={`notif-${n.id}`}>
              <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: sev.bg, color: sev.c }}><Icon size={19} /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <p className="font-semibold text-sm">{n.title}</p>
                  <span className="pill px-2 py-0.5 text-[10px] border-subtle text-muted-c">{n.employee}</span>
                  {!r && <span className="w-2 h-2 rounded-full brand-bg" />}
                </div>
                <p className="text-sm text-secondary mt-0.5">{n.message}</p>
              </div>
              {!r && <button onClick={() => readOne(n.id)} className="text-xs brand-text font-semibold hover:underline shrink-0" data-testid={`read-${n.id}`}>Mark read</button>}
            </div>
          );
        })}
        {!items.length && <Empty text="No alerts — all tasks are on track" />}
      </div>
    </div>
  );
}
